import React, { useState } from "react"
import { EditBandFormField } from "./EditBandFormField"
import { Band } from "../../types/bands"

interface TemplateProps {
  band: Band
}

interface TemplateOption {
  value: string | null
  label: string
}

export const Template: React.FC<TemplateProps> = ({ band }) => {
  const [template, setTemplate] = useState<string | null>(
    band?.template_name || null,
  )

  const TEMPLATE_OPTIONS: TemplateOption[] = [
    {
      value: null,
      label: "Choose a template",
    },
    {
      value: "basic",
      label: "Classic bandNada",
    },
    {
      value: "timeline",
      label: "Timeline",
    },
    {
      value: "scroller",
      label: "Scroller",
    },
  ]

  const notes = (
    <span>
      Scroller is recommended, it gives you a single-page layout with a
      sticky tab bar to jump between shows, music, posts, and more. Classic
      will give you the standard page with all of your content divided by
      content type. Timeline shows more of a feed based on recency of items.
    </span>
  )

  const fieldData = {
    field: "template_name",
    name: "template_name",
    label: "Template",
    placeholder: "Template",
    required: true,
    notes: notes,
  }

  return (
    <EditBandFormField
      type="select"
      value={template}
      setValue={setTemplate}
      options={TEMPLATE_OPTIONS}
      fieldData={fieldData}
      bandId={band.id}
      isArray={false}
    />
  )
}
